<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" inline label-width="100px">
        <el-form-item label="审核状态：">
          <el-select size="small" v-model="listParams.status" placeholder="请选择审核状态">
            <el-option value label="全部"></el-option>
            <el-option value="01" label="已登记"></el-option>
            <el-option value="02" label="已保障"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保障手机号：">
          <el-input maxlength="11" size="small" v-model="listParams.mobile" placeholder="请输入保障手机号"></el-input>
        </el-form-item>
        <el-form-item label="保障级别：">
          <el-select v-model="listParams.supplyLevelId" size="small" placeholder="请选择保障级别" clearable="">
            <el-option v-for="item in levelList" :label="item.levelName" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate">新增</el-button>

          <form enctype="multipart/form-data">
            <el-upload
              ref="upload"
              class="upload-btn mgl20"
              accept="file"
              :headers="headers"
              :show-file-list="false"
              :action="uploadAction"
              :data="uploadParams"
              :before-upload="beforeUpload"
              :on-success="successCallback"
              :on-error="errorCallback"
            >
              <el-button size="small" type="success">批量导入保障用户</el-button>
            </el-upload>
          </form>

          <el-button class="align-left mgl20" type="primary" size="small" :disabled="tableData.length === 0" @click="exportExcel">
            导出保障用户
          </el-button>

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="status" align="center" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === '01'" style="color: teal">已登记</span>
            <span v-if="scope.row.status === '02'" style="color: rgba(0, 167, 0, 0.63)">已保障</span>
            <span v-if="scope.row.status === '03'" style="color: gray">已禁用</span>
          </template>
        </el-table-column>

        <el-table-column prop="vipMobile" align="center" label="保障手机号"></el-table-column>

        <el-table-column prop align="center" label="供应点">
          <template slot-scope="scope">
            <span v-if="scope.row.logisticsSite">{{ scope.row.logisticsSite.name }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="registerDate" align="center" label="注册时间">
          <template slot-scope="scope">{{ scope.row.registerDate | formatDate }}</template>
        </el-table-column>

        <el-table-column prop="supplyLevelName" align="center" label="保障级别">
          <template slot-scope="scope">{{ scope.row.supplyLevelName || "-" }}</template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="changeItem(scope.row)" v-if="scope.row.status != '03'">编辑</el-button>
            <el-button type="text" @click="handleSync(scope.row)" v-if="scope.row.orderUpdateStatus">订单同步</el-button>

            <confirm-button
              v-if="scope.row.status === '02'"
              type="text"
              style="margin: 0 10px"
              title="确认要禁用该登记保障用户？"
              @confirmed="confirmChangeUserStatus(scope.row)"
            >
              <span class="color-warning">禁用</span>
            </confirm-button>

            <confirm-button
              v-if="scope.row.status === '03'"
              type="text"
              style="margin: 0 10px"
              title="确认要恢复该登记保障用户？"
              @confirmed="confirmChangeUserStatus(scope.row)"
            >
              <span class="color-success">恢复</span>
            </confirm-button>

            <confirm-button
              v-if="scope.row.status === '01' || scope.row.status === '02'"
              type="text"
              title="确认要删除该登记保障用户？"
              @confirmed="deleteItem(scope.row.id, scope.row.status)"
            >
              <span class="color-danger">删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <!-- 保障用户编辑 -->
    <DialogEdit :dialogVisible.sync="dialogVisible" :dialogData="dialogData" :supplyId="listParams.supplyId" @refresh="handleSearch" />

    <!-- 订单供应点同步 -->
    <DialogOrders :dialogVisible.sync="dialogOrders" :dialogData="dialogData" @refresh="handleSearch" />
  </div>
</template>

<script>
import Vue from "vue";
import DialogEdit from "./components/DialogEdit.vue";
import DialogOrders from "./components/DialogOrders.vue";
import { download } from "../../../../utils/javascript/download";

export default {
  components: { DialogEdit, DialogOrders },

  data() {
    return {
      listParams: {
        status: "",
        mobile: "",
        supplyLevelId: "",
        supplyId: ""
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      levelList: [],
      dialogVisible: false,
      dialogData: {},
      exportUrl: "/supply/supplyUserReserve/findByPage/export",
      dialogOrders: false
    };
  },

  computed: {
    uploadAction() {
      return global.apiUrl + "/supply/supplyUserReserve/batchImport";
    },
    uploadParams() {
      return {
        supplyId: parseInt(this.$route.params.supplyId)
      };
    },
    headers() {
      return {
        "X-CA-Token": localStorage.getItem("TOKEN")
      };
    }
  },

  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadTableData();
    this.loadLevelList();
  },

  methods: {
    /**
     * 查询
     */
    handleSearch() {
      this.pager.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 加载列表数据
     */
    async loadTableData() {
      const params = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      try {
        const url = global.apiUrl + "/supply/supplyUserReserve/findByPage";
        const response = await Vue.ajaxGet(this, url, params, "tableLoading");
        const data = response || {};
        this.tableData = data.dataList || [];
        this.pager.total = data.total || 0;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 上传前的操作
     * @param file
     */
    beforeUpload(file) {
      const Xls = file.name.split(".");
      if (Xls[1] === "xls" || Xls[1] === "xlsx") {
        return true;
      } else {
        this.$message.error("上传文件只能是 xls/xlsx 格式!");
        return false;
      }
    },
    /**
     * 成功回调
     * @param res
     * @param file
     * @param fileList
     */
    successCallback(res, file, fileList) {
      if (res.apiStatus === 0 && res.sysStatus === 0) {
        this.$message.success(res.info);
        this.loadTableData();
      } else {
        this.$message.error(res.info);
      }
    },
    /**
     * 错误回调
     * @param err
     * @param file
     * @param fileList
     */
    errorCallback(err, file, fileList) {
      this.$message.error(err);
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },

    /**
     * 加载保障级别列表
     */
    async loadLevelList() {
      const params = { supplyId: this.listParams.supplyId, pageIndex: 1, pageSize: 999 };
      try {
        const url = global.apiUrl + "/supply/level";
        const response = await Vue.ajaxGet(this, url, params, "tableLoading");
        this.levelList = response.data || [];
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 新增保障用户
     */
    toCreate() {
      this.dialogData = {};
      this.dialogVisible = true;
    },
    /**
     * 修改条目数据
     * @param row
     */
    changeItem(row) {
      this.dialogData = {
        id: row.id,
        status: row.status,
        logisticsSiteId: row.logisticsSite.id,
        phone: row.vipMobile,
        updatePhone: row.vipMobile,
        supplyId: row.supplyId,
        supplyLevelId: row.supplyLevelId
      };
      this.dialogVisible = true;
    },

    /**
     * 订单同步
     * @param {*} data
     */
    handleSync(data) {
      this.dialogData = { accountId: data.id, newLogisticSiteId: data.logisticsSite.id };
      this.dialogOrders = true;
    },

    /**
     * 禁用/恢复 保障用户状态
     */
    async confirmChangeUserStatus(row) {
      let disable = false;
      if (row.status == "02") {
        disable = true;
      }
      const params = { id: row.id, disable: disable };
      try {
        const url = global.apiUrl + "/supply/updateUserStatus";
        const response = await Vue.ajaxPut(this, url, params, "tableLoading");
        this.$message.success(response.info);
        this.handleSearch();
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 删除条目数据
     * @param id
     * @param status
     */
    async deleteItem(id, status) {
      try {
        const url = global.apiUrl + "/supply/supplyUserReserve?id=" + id + "&status=" + status;
        const response = await Vue.ajaxDel(this, url);
        this.$message.success(response.info);
        this.handleSearch();
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 导出EXCEL
     */
    exportExcel() {
      download(this.exportUrl, this.listParams, "用户管理");

      // this.$router.open({
      //   path: this.exportUrl,
      //   query: this.listParams,
      //   type: "excel"
      // });
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
